import React from "react";

import Cotizacion2 from "../../components/CotizacionFinanciero/CotizacionFinanciero2";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchConsultarCarritoFinanciero,fetchDataFinanciero, fetchGuardarCarritoFinanciero} from "../../redux/actions/aRamoLineaFinanciera";
import {encriptarTramaAES} from "../../utils/Encriptar/index";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";
class ContainerCotizacionFinanciero2 extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {};
    this.handleBack = this.handleBack.bind(this);
  }

  async componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    let datosJSON ='';
    if(queryParams.get('id') !== null){
        /*Consulta Carrito*/  
        datosJSON = {
          idCarrito: queryParams.get('id')
        }
    }else{   
      /*Consulta Carrito*/  
      datosJSON = {
          idCarrito: this.props.respuestaCarrito.respuestaGuardarFinanciero.idCarrito,
      }
    }
    const encriptado = encriptarTramaAES(JSON.stringify(datosJSON));
    await this.props.consultarCarrito(Buffer.from(JSON.stringify(encriptado)).toString('base64'));
    
    // llamar a la lista de ingresos y de preguntas la
    // primera ves, no cuando se regresa de un paso superior
    if( queryParams.get('preservar')===null || queryParams.get('preservar')==='no' ){
        if(this.props.detalleCarrito.datosCarritoFinanciero.ultimoPaso.pasoNumero === "2" && !this.props.detalleCarrito.datosCarritoFinanciero.ultimoPaso.resultado.transaccion){
          await this.props.listarDatos('');
        }else{
          await this.props.listarDatos(this.props.detalleCarrito.datosCarritoFinanciero.carSeguro);
        }
    }
  }

  /**
   * Regresar al anterior paso
   */
  async handleBack() {
      // cotizador actual seleccionado
      const codRamo = this.props.detalleCarrito.datosCarritoFinanciero.carSeguro
      // actualizar los datos, para que se precarguen correctamente en el paso anterior
      const datosJSON = {
        idCarrito: this.props.respuestaCarrito.respuestaGuardarFinanciero.idCarrito,
      }
      // encriptar body y enviar al servicio
      const encriptado = encriptarTramaAES(JSON.stringify(datosJSON))
      await this.props.consultarCarrito(Buffer.from(JSON.stringify(encriptado)).toString('base64'))
      // actualizar el ultimo paso en el servicio
      // const datosJSON2 = {
      //   paso:`${paso}`,
      //   preguntas: {idCarrito: this.props.respuestaCarrito.respuestaGuardarFinanciero.idCarrito}
      // }
      // const encriptado2 = await encriptarTramaAES(JSON.stringify(datosJSON2));
      // await this.props.guardarCarrito({"Data": Buffer.from(JSON.stringify(encriptado2)).toString('base64')});
      if(/* this.props.respuestaCarrito.respuestaGuardarFinanciero.errorDescripcion===undefined */ 
          !this.props.detalleCarrito.consultarCarritoFinancierohasError){
          /*Pasa a la siguiente pantalla*/      
          this.props.history.push({
            pathname: '/cotizacion-financiero',
            // ramo 42 y codigo producto 120 corresponden a D&O
            // ramo 49 y codigo producto 121 corresponde a Cyber
            search: `?${
              new URLSearchParams({
                idProducto: codRamo,
                preservar:'si'
              }).toString()
            }`
          });
      }
  }

  render() {
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <LoadingScreen
                loading={this.props.detalleCarrito.consultarCarritoFinancieroIsLoading || this.props.listarPreguntas.FinancieroisLoading}
                bgColor="#f1f1f1"
                spinnerColor="#001871"
                textColor="#676767"
                logoSrc={logo}
                text="Cargando datos..."
              >
                <Cotizacion2 detalleCarrito={this.props.detalleCarrito.datosCarritoFinanciero} 
                listarPreguntas={Object.keys(this.props.listarPreguntas.listarPreguntas).length > 0 ? 
                this.props.listarPreguntas.listarPreguntas : this.props.detalleCarrito.datosCarritoFinanciero.preguntasConfirmacion }
                handleBack={this.handleBack} preservar={new URLSearchParams(this.props.location.search).get('preservar')} />
              </LoadingScreen>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  detalleCarrito : state.datosCarritoFinanciero,
  listarPreguntas :state.dataFinanciero,
  respuestaCarrito : state.datosCotizacionFinanciero
});

const mapDispatchToProps = dispatch => {
  return {
    listarDatos: (codProducto) => dispatch(fetchDataFinanciero(codProducto)),
    consultarCarrito: (data) => dispatch(fetchConsultarCarritoFinanciero(data)),
    guardarCarrito: (data) => dispatch(fetchGuardarCarritoFinanciero(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCotizacionFinanciero2)
);
